import { CookieService } from "@ngx-toolkit/cookie";
import { Injectable } from '@angular/core';
import { Buffer } from "buffer";

@Injectable()
export class StorageService {

    private options:StorageOptions
    constructor(private cookieService:CookieService){
    }

    public hydrate( storageKey: string, obj: object, options?: StorageOptions):void{
        if(!options) options = StorageOptions.ForEver;
        let now = new Date();

        var str = JSON.stringify(obj);
        var b64 = new Buffer(str).toString('base64');

        this.cookieService.setItem(storageKey, b64, {
            expires: 120*60
        });
    }

    public dehydate(storageKey:string): any{
        var b64 = this.cookieService.getItem(storageKey);
        var str = Buffer.from(b64, 'base64').toString('utf-8');

        return JSON.parse(str);
    }

    public hasHydratedData(storageKey: string): boolean{
        return this.cookieService.hasItem(storageKey);
    }

    public erase(storageKey:string):void{
        this.cookieService.removeItem(storageKey);
    }
}

export enum StorageOptions{
    Hour,
    Day,
    ForEver
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/storage-service.client.ts